"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/samJdStoreApi"));
var _SamSkuDetail = _interopRequireDefault(require("./components/SamSkuDetail.vue"));
var _SamGoodsPriceAdjustDialog = _interopRequireDefault(require("./components/SamGoodsPriceAdjustDialog.vue"));
var _SamGoodsPriceRecordDialog = _interopRequireDefault(require("./components/SamGoodsPriceRecordDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SamSkuList',
  components: {
    SamSkuDetail: _SamSkuDetail.default,
    SamGoodsPriceAdjustDialog: _SamGoodsPriceAdjustDialog.default,
    SamGoodsPriceRecordDialog: _SamGoodsPriceRecordDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.pageLyp.limit[0],
        cate1: '',
        cate2: '',
        cate3: '',
        brandName: '',
        skuid: '',
        productName: '',
        sortType: '',
        status: '',
        deliveryType: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      exportLoading: false,
      cate1Options: [],
      cate2Options: [],
      cate3Options: [],
      cate1Loading: false,
      cate2Loading: false,
      cate3Loading: false,
      sortOptions: [],
      sortLoading: false,
      clearCacheLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
    this.fetchCate1Options('');
    this.fetchSortOptions();
  },
  methods: {
    formatCategory: function formatCategory(row) {
      if (!row) return '--';
      var a = row.categoryOneName || '';
      var b = row.categoryTwoName || '';
      var c = row.categoryThreeName || '';
      var text = [a, b, c].filter(function (s) {
        return s;
      }).join('/');
      return text || '--';
    },
    getPriceDiff: function getPriceDiff(row) {
      if (row.salePrice == null || row.retail == null) return 0;
      var diff = parseFloat(row.salePrice) - parseFloat(row.retail);
      if (Math.abs(diff) < 0.001) return 0;
      return diff;
    },
    getPriceClass: function getPriceClass(row) {
      var diff = this.getPriceDiff(row);
      if (diff > 0) return 'price-up';
      if (diff < 0) return 'price-down';
      return '';
    },
    getAdjustRatio: function getAdjustRatio(row) {
      if (row.salePrice == null || row.retail == null) return '--';
      var diff = parseFloat(row.salePrice) - parseFloat(row.retail);
      if (Math.abs(diff) < 0.001) return '--';
      var ratio = (diff / parseFloat(row.retail) * 100).toFixed(2);
      return ratio;
    },
    formatListStatus: function formatListStatus(v) {
      if (String(v) === '1') return '上架';
      if (String(v) === '0') return '下架';
      return '--';
    },
    formatYn: function formatYn(v) {
      if (String(v) === '1') return '有效';
      if (String(v) === '2') return '无效';
      return '--';
    },
    formatManualAdjust: function formatManualAdjust(v) {
      if (String(v) === '1') return '是';
      if (String(v) === '0') return '否';
      return '--';
    },
    formatSelfSellType: function formatSelfSellType(v) {
      if (String(v) === '1') return '山姆自营';
      if (String(v) === '0') return '非自营';
      return '--';
    },
    formatLogisticsType: function formatLogisticsType(v) {
      if (String(v) === '0') return '第三方配送';
      if (String(v) === '1') return '山姆配送';
      if (String(v) === '2') return '未知类型';
      return '--';
    },
    fetchSortOptions: function fetchSortOptions() {
      var _this = this;
      if (this.sortLoading) return Promise.resolve();
      this.sortLoading = true;
      return jdStoreApi.getJdMallSortOptions().then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res.data || res;
        var list = Array.isArray(data) ? data : Array.isArray(data.data) ? data.data : [];
        _this.sortOptions = (Array.isArray(list) ? list : []).map(function (it) {
          return {
            value: String(it.id),
            label: String(it.name)
          };
        });
      }).catch(function () {
        _this.sortOptions = [];
      }).finally(function () {
        _this.sortLoading = false;
      });
    },
    getGoodsListRequestBody: function getGoodsListRequestBody() {
      var p = this.listPram || {};
      var logisticsTypeMap = {
        third: 0,
        jd: 1,
        unknown: 2
      };
      var logisticsType = p.deliveryType === '' || p.deliveryType === undefined || p.deliveryType === null ? undefined : logisticsTypeMap[p.deliveryType] !== undefined ? logisticsTypeMap[p.deliveryType] : p.deliveryType;
      return {
        page: p.page,
        limit: p.limit,
        brandName: p.brandName || undefined,
        categoryOne: p.cate1 || undefined,
        categoryTwo: p.cate2 || undefined,
        categoryThree: p.cate3 || undefined,
        skuId: p.skuid || undefined,
        skuName: p.productName || undefined,
        sort: p.sortType || undefined,
        listStatus: p.status === '' ? undefined : p.status,
        logisticsType: logisticsType
      };
    },
    fetchCate1Options: function fetchCate1Options(keyword) {
      var _this2 = this;
      this.cate1Loading = true;
      return jdStoreApi.getJdCategoryOneList({
        keyword: keyword || ''
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this2.cate1Options = list;
      }).catch(function () {
        _this2.cate1Options = [];
      }).finally(function () {
        _this2.cate1Loading = false;
      });
    },
    fetchCate2Options: function fetchCate2Options(keyword) {
      var _this3 = this;
      if (!this.listPram.cate1) {
        this.cate2Options = [];
        return Promise.resolve();
      }
      this.cate2Loading = true;
      return jdStoreApi.getJdCategoryTwoList({
        keyword: keyword || '',
        categoryOneId: this.listPram.cate1
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this3.cate2Options = list;
      }).catch(function () {
        _this3.cate2Options = [];
      }).finally(function () {
        _this3.cate2Loading = false;
      });
    },
    fetchCate3Options: function fetchCate3Options(keyword) {
      var _this4 = this;
      if (!this.listPram.cate2) {
        this.cate3Options = [];
        return Promise.resolve();
      }
      this.cate3Loading = true;
      return jdStoreApi.getJdCategoryThreeList({
        keyword: keyword || '',
        categoryTwoId: this.listPram.cate2
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this4.cate3Options = list;
      }).catch(function () {
        _this4.cate3Options = [];
      }).finally(function () {
        _this4.cate3Loading = false;
      });
    },
    onSortVisibleChange: function onSortVisibleChange(visible) {
      if (visible) this.fetchSortOptions();
    },
    onCate1Change: function onCate1Change() {
      this.listPram.cate2 = '';
      this.listPram.cate3 = '';
      this.cate2Options = [];
      this.cate3Options = [];
      if (this.listPram.cate1) this.fetchCate2Options('');
    },
    onCate2Change: function onCate2Change() {
      this.listPram.cate3 = '';
      this.cate3Options = [];
      if (this.listPram.cate2) this.fetchCate3Options('');
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        cate1: '',
        cate2: '',
        cate3: '',
        brandName: '',
        skuid: '',
        productName: '',
        sortType: '',
        status: '',
        deliveryType: ''
      };
      this.cate2Options = [];
      this.cate3Options = [];
      this.handlerGetListData();
    },
    handleClearCache: function () {
      var _handleClearCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.clearCacheLoading = true;
              _context.p = 1;
              _context.n = 2;
              return jdStoreApi.clearSmMallCache();
            case 2:
              this.$message.success('缓存已清除');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('清除缓存失败');
            case 4:
              _context.p = 4;
              this.clearCacheLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleClearCache() {
        return _handleClearCache.apply(this, arguments);
      }
      return handleClearCache;
    }(),
    handlerGetListData: function handlerGetListData() {
      var _this5 = this;
      this.listLoading = true;
      var body = this.getGoodsListRequestBody();
      jdStoreApi.getJdSkuList(body).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res.data || res;
        var list = Array.isArray(data.list) ? data.list : [];
        var total = data.total || 0;
        _this5.listData = {
          list: list,
          total: total
        };
      }).catch(function () {
        _this5.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this5.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    handleExport: function handleExport() {
      var _this6 = this;
      this.exportLoading = true;
      jdStoreApi.exportJdSkuList(this.listPram).then(function () {
        _this6.$message.success('导出任务已提交');
      }).catch(function () {
        _this6.$message.error('导出失败');
      }).finally(function () {
        _this6.exportLoading = false;
      });
    },
    handleImport: function handleImport() {
      this.$message.info('导入商品列表功能待对接');
    },
    handleListStatusChange: function handleListStatusChange(row, val) {
      var _this7 = this;
      var skuId = row && row.skuId;
      var newStatus = val;
      var oldStatus = newStatus === 1 ? 0 : 1;
      if (skuId === undefined || skuId === null || skuId === '') {
        this.$message.error('缺少skuId');
        this.$set(row, 'listStatus', oldStatus);
        return;
      }
      jdStoreApi.updateJdGoodsStatus({
        skuId: skuId,
        listStatus: newStatus
      }).then(function (res) {
        if (res == '操作成功') {
          _this7.$message.success('操作成功');
          _this7.handlerGetListData();
          return;
        }
        _this7.handlerGetListData();
        _this7.$set(row, 'listStatus', oldStatus);
        _this7.$message.error(res && res.message || '操作失败');
      }).catch(function () {
        _this7.handlerGetListData();
        _this7.$set(row, 'listStatus', oldStatus);
        _this7.$message.error('操作失败');
      });
    },
    openDetail: function openDetail(row) {
      this.$refs.samSkuDetailRef && this.$refs.samSkuDetailRef.open(row);
    },
    openPriceAdjust: function openPriceAdjust(row) {
      this.$refs.samGoodsPriceAdjustRef && this.$refs.samGoodsPriceAdjustRef.open(row);
    },
    openPriceRecord: function openPriceRecord(row) {
      this.$refs.samGoodsPriceRecordRef && this.$refs.samGoodsPriceRecordRef.open(row);
    }
  }
};